<template>
    <div class="wapper flex flex-direction">
        <div class="flex flex-direction bg-white radius padding-sm">
            <div class="flex align-center">
                <div class="text-black text-bold text-df">内设内容</div>
            </div>
            <div class="flex flex-direction">
                <div v-for="(item,index) in basics" :key="index" class="items">
                    <div class="item-name">{{ item.type_name }}</div>
                    <div class="item-btn">
                        <el-button round type="primary" @click="toPage(`/web/admin/card/edit/${item.id}`)">
                            <i class="el-icon-edit"></i>编辑
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-direction margin-top-sm  bg-white radius padding-sm flex-sub">
            <div class="flex align-center justify-between">
                <div class="text-black text-bold text-df">自定义版块列表</div>
                <el-button round type="warning" @click="addMode(false)">新建版块</el-button>
            </div>
            <div class="flex flex-direction">
                <div v-for="(item,index) in list" :key="index" class="items">
                    <div class="item-name">{{ item.type_name }}</div>
                    <div class="item-time">创建于：{{ item.create_time }}</div>
                    <div class="item-btn">
                        <el-button  round type="primary" @click="toPage(`/web/admin/card/edit/${item.id}`)">
                            <i class="el-icon-edit"></i>编辑
                        </el-button>
                        <el-button plain round @click="delItem(item)">
                            <i class="el-icon-delete"></i>删除
                        </el-button>
                    </div>
                </div>
                <el-empty description="您还没有分类，快去添加一个吧？" v-if="!list.length"></el-empty>
            </div>
        </div>
        <el-dialog
            :before-close="handleClose"
            :close-on-click-modal="false"
            :visible.sync="addDialogVisible"
            append-to-body
            custom-class="setTitle"
            width="30%">
            <div slot="title" class="dialogTitle">添加自定义版块</div>
            <div class="dialogBox">
                <el-input ref="input" v-model="cur_title" placeholder="请输入自定义版块名称"></el-input>
            </div>
            <span slot="footer" class="dialog-footer">
               <el-button class="btn" type="primary" @click="submitMode">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {confirm, TOAST, toast, zhDate} from "@/utils/utils";
import {contentTypeList, createContentType, contentTypeDel} from "@/api";
import {basic_classify} from "@/utils/const";

export default {
    name: "list",
    data() {
        return {
            basics:basic_classify,
            list: [],  //  自定义列表
            cur_id: 0,
            cur_title: '',   //  自定义模块名称
            addDialogVisible: false,
        }
    },
    created() {
        this.$emit('setIndex', [1, 1], '内容管理')
        this.init()
    },
    methods: {
        async init() {
            let _data = await contentTypeList()
            _data.data.map(item => {
                item.create_time = zhDate(item.create_time * 1000,1)
            })
            this.list = _data.data
        },
        addMode(data) {
            if (data) {
                this.cur_title = data.title;
                this.cur_id = data.id;
            } else {
                this.cur_title = '';
                this.cur_id = 0;
            }
            this.addDialogVisible = true
        },
        //  确定添加
        async submitMode() {
            if (!this.cur_title) return toast('请输入自定义版块名称', TOAST.error)
            let _data = await createContentType(this.cur_title)
            if (_data.status === 200) {
                this.init()
                this.handleClose()
                toast(_data.msg)
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        delItem(item) {
            confirm('删除', `您确定要删除${item.type_name}吗？`, () => {
                this.delMode(item.id)
            },'确定',true)
        },
        async delMode(id) {
            let _data = await contentTypeDel(id)
            if (_data.status === 200) {
                this.init()
                toast('删除成功')
            } else {
                toast(_data.msg, TOAST.error)
            }
        },
        handleClose() {
            this.addDialogVisible = false
        },
        toPage(path) {
            this.$router.push(path)
        }
    }
}
</script>

<style lang="scss" scoped>
.wapper {
    .items {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 70px;
        padding: 10px 20px;
        line-height: 50px;
        border-bottom: 1px solid #f3f3f3;

        .item-name {
            width: 400px;
        }

        .item-time {
            width: 200px;
        }

        .item-btn {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 300px;

            .btns {
                border-color: #d9dde3;
                i {
                    font-size: 18px;
                    margin-right: 3px;
                    position: relative;
                    top: 2px;
                }
            }
        }
    }
}
</style>